import { Link } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { hmLightTheme } from "../themes/hmTheme";

const FieldShow = ({ ...props }) => {
  const navigate = useNavigate();
  const title = props.title;
  const value = props.value;
  const isBreak = props.isBreak;
  const disabled = props.disabled;
  const link = props.link;
  //后缀
  const endText = props?.endText || "";
  let textcolor = "textSecondary";
  let fontFamily = hmLightTheme?.palette?.textFontFamily;
  let valueFontFamily = hmLightTheme?.palette?.textFontFamily;

  valueFontFamily =
    props.fontFamily == "numberFontFamily"
      ? hmLightTheme?.palette?.numberFontFamily
      : hmLightTheme?.palette?.textFontFamily;

  if (disabled == "Yes") {
    textcolor = "#d5d5d5";
  } else {
    textcolor = "textSecondary";
  }

  return (
    <Typography variant="body2" color={textcolor} sx={{ mb: 1 }}>
      {title ? <b>{title + `: `} </b> : ""}
      {/* {title ? title + `: ` : ""} */}
      {isBreak ? <br /> : <></>}
      {link ? (
        <Link
          href={link}
          sx={{
            cursor: "pointer",
            textDecoration: "none",
            fontFamily: hmLightTheme?.palette?.numberFontFamily,
            "&.RaLink-link": {
              color: "#1976d2",
            },
            "&:hover": {
              textDecoration: "underline",
            },
          }}
        >
          {value}
        </Link>
      ) : (
        <span
          style={{
            fontFamily: valueFontFamily ? valueFontFamily : "Proxima Nova",
          }}
        >
          {value && value != "null" ? value : ""}
          {endText ? " " + endText : ""}
        </span>
      )}
    </Typography>
  );
};

export default FieldShow;
